import {Injectable} from '@angular/core';
import {CookieService} from "ngx-cookie-service";

@Injectable({
    providedIn: 'root'
})
export class GoogleAnalyticsService {

    constructor(private cookieService: CookieService,) {
    }

    getClientId() {
        return this.parseClientId(this.cookieService.get('_ga'));
    }

    getSessionId() {
        return this.parseSessionId(this.cookieService.get('_ga_VKZ2TF2G9C'));
    }

    private parseClientId(gaCookie: string | null): string | null {
        if (!gaCookie) {
            return null;
        }

        let parts = gaCookie.split('.');
        return parts.length >= 4 ? `${parts[2]}.${parts[3]}` : null;
    }

    private parseSessionId(gaSessionCookie: string | null): string | null {
        if (!gaSessionCookie) {
            return null;
        }

        let parts = gaSessionCookie.split('.');

        if (parts.length >= 3) {
            let sessionSegment = parts[2];
            let subParts = sessionSegment.split('$');
            let sessionIdWithPrefix = subParts[0];

            return sessionIdWithPrefix.substring(1);
        }

        return null;
    }
}
